import React from 'react';
import { Typography, Box, Button, Paper, Stack } from '@mui/material';
import LockPersonOutlinedIcon from '@mui/icons-material/LockPersonOutlined';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { useNavigate } from 'react-router-dom';
import Layout from '../layout/layout';

const AccessDenied = ({ toggleTheme }) => {
  const navigate = useNavigate();

  return (
    <Layout toggleTheme={toggleTheme}>
      <Box
        sx={{
          minHeight: '70vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          px: 2,
        }}
      >
        <Paper
          elevation={0}
          sx={{
            maxWidth: 480,
            width: '100%',
            p: { xs: 3, sm: 5 },
            textAlign: 'center',
            borderRadius: 3,
            border: (theme) => `1px solid ${theme.palette.divider}`,
            bgcolor: (theme) =>
              theme.palette.mode === 'dark' ? 'background.paper' : '#ffffff',
          }}
        >
          {/* Security / Restricted Icon Accent */}
          <Box
            sx={{
              width: 64,
              height: 64,
              borderRadius: '50%',
              bgcolor: (theme) =>
                theme.palette.mode === 'dark' ? 'rgba(211, 47, 47, 0.15)' : '#fde8e8',
              color: 'error.main',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              mx: 'auto',
              mb: 2.5,
            }}
          >
            <LockPersonOutlinedIcon sx={{ fontSize: 32 }} />
          </Box>

          <Typography variant="h3" fontWeight={700} gutterBottom>
            Access Restricted
          </Typography>

          <Typography
            variant="body2"
            sx={{ color: 'text.secondary', mb: 3.5, lineHeight: 1.6 }}
          >
           You do not have the required privileges to view this page. Please
            contact your administrator to request permissions.
          </Typography>

          {/* Action Buttons */}
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={1.5}
            justifyContent="center"
          >
            <Button
              variant="contained"
              disableElevation
              onClick={() => navigate(-1)}
              sx={{ borderRadius: 2 }}
            >
               Go Back
            </Button>
          </Stack>
        </Paper>
      </Box>
    </Layout>
  );
};

export default AccessDenied;
